<template>
  <div class="page">
    <div class="page-header">
      <div class="header-text">
        <h1 v-html="focus.cartouche ? focus.cartouche.titre : ''"></h1>
        <p v-html="focus.cartouche ? focus.cartouche.texte : ''"></p>
      </div>
      <img class="header-img" src="../../assets/images/patrimoine/pierres-zen-sont-arriere-plan-pyramide-galets-fond-ciel-mer-plage.jpg">
    </div>
    <div class="page-content">
      <div class="patrimoine">
        <h4>Organiser votre patrimoine</h4>
        <div class="patrimoine-icn-container">
          <div>
            <img src="../../assets/icons/icn-prapluie.svg">
            <p>Protéger son conjoint</p>
          </div>
          <div>
            <img src="../../assets/icons/icn-d-pendance.svg">
            <p>Penser au sujet de la dépendance</p>
          </div>
          <div>
            <img src="../../assets/icons/icn-retraite.svg">
            <p>Anticiper sa retraite</p>
          </div>
          <div>
            <img src="../../assets/icons/icn-prapluie.svg">
            <p>Diminuer son impôt sur le revenu</p>
          </div>
          <div>
            <img src="../../assets/icons/icn-epargne.svg">
            <p>Valoriser son épargne</p>
          </div>
          <div>
            <img src="../../assets/icons/icn-transmettre.svg">
            <p>Anticiper la transmission de son entreprise</p>
          </div>
          <div>
            <img src="../../assets/icons/icn-assurance.svg">
            <p>Auditer ses contrats d’assurance</p>
          </div>
          <div>
            <img src="../../assets/icons/icn-banque.svg">
            <p>Créer du revenu complémentaire</p>
          </div>
        </div>
      </div>
      <div>
        <h3 v-html="focus.paragraphe1 ? focus.paragraphe1.titre : ''"></h3>
        <p v-html="focus.paragraphe1 ? focus.paragraphe1.texte : ''"></p>
        <div class="img-wrapper">
          <img :src="focus.paragraphe1 ? focus.paragraphe1.image : ''">
        </div>
        <h3 v-html="focus.paragraphe2 ? focus.paragraphe2.titre : ''"></h3>
        <p v-html="focus.paragraphe2 ? focus.paragraphe2.texte : ''"></p>
        <div class="img-wrapper">
          <img :src="focus.paragraphe2 ? focus.paragraphe2.image : ''">
        </div>
        <h3 v-html="focus.paragraphe3 ? focus.paragraphe3.titre : ''"></h3>
        <p v-html="focus.paragraphe3 ? focus.paragraphe3.texte : ''"></p>
        <div class="img-wrapper">
          <img :src="focus.paragraphe3 ? focus.paragraphe3.image : ''">
        </div>
        <h3 v-html="focus.paragraphe4 ? focus.paragraphe4.titre : ''"></h3>
        <p v-html="focus.paragraphe4 ? focus.paragraphe4.texte : ''"></p>
        <div class="img-wrapper">
          <img :src="focus.paragraphe4 ? focus.paragraphe4.image : ''">
        </div>
        <h3 v-html="focus.paragraphe5 ? focus.paragraphe5.titre : ''"></h3>
        <p v-html="focus.paragraphe5 ? focus.paragraphe5.texte : ''"></p>
        <div class="img-wrapper">
          <img :src="focus.paragraphe5 ? focus.paragraphe5.image : ''">
        </div>
      </div>
    </div>
    <div class="form-link-wrapper">
      <div class="form-link-container">
        <div>
          <h4 v-html="focus.formulaire ? focus.formulaire.titre : ''"></h4>
          <p v-html="focus.formulaire ? focus.formulaire.texte : ''"></p>
          <router-link :to="{ name: 'EtudePatrimonialeForm' }">
              <button class="cg-btn cg-btn-primary">Commencez maintenant</button>
          </router-link>
        </div>
      </div>
    </div>
    <site-link siteName="Patrimoine"></site-link>
  </div>
</template>

<script>
import { getFocus } from '../../mixins/getFocus'
import SiteLink from '../Components/SiteLink.vue'

export default {
  name: 'Ingenierie',
  mixins: [getFocus],
  components: {
    SiteLink
  },
  data() {
    return {
      focus: {}
    }
  },
  async beforeMount() {
    this.getFocus('gp', 'Ingénierie & conseils patrimoniaux')
    .then(res => {
        this.focus = res
    })
  }
}
</script>

<style lang="scss" scoped>
.page-content {

  .patrimoine {
    max-width: var(--max-width);
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    padding: 64px 0;

    .patrimoine-icn-container {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-wrap: wrap;

      &>div {
        width: 260px;
        height: 176px;
        border-radius: 10px;
        box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.2);
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding-top: 24px;
        margin: 12px;

        &>p {
          font-size: 1.2rem;
          font-weight: 600;
          text-align: center;
        }
      }
    }
  }
}

</style>
